import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './language/index'

import NavBar from './components/NavBar.vue'

const app = createApp(App)

app.component('NavBar', NavBar)

app.use(store).use(router).use(i18n).mount('#app')
